module.exports = __webpack_public_path__ + "static/media/pickup.c5abc3ae.svg";